import { Holiday } from '@/plugins/api'
import alert from '@/plugins/alert'
import { rangeRight } from 'lodash-es'

export default {
  namespaced: true,
  state: {
    holidays: [],
    holiday: {},
    searchParams: {},
    pageText: '',
    count: 0,
    itemsPerPage: 10,
    totalItems: 0,
    loading: false,
    affectedClasses: [],
    getClassLoading: false,
  },
  actions: {
    async searchHolidays({ commit, state, dispatch }, query) {
      const params = {
        _limit: state.itemsPerPage,
        ...query,
      }
      commit('changeState', { searchParams: params })
      dispatch('requestPageSettings', {})
    },
    async requestPageSettings({ state, commit, dispatch }, { page, itemsPerPage, category, type }) {
      commit('changeState', { loading: true })
      if (!page) page = 1
      if (!itemsPerPage) itemsPerPage = state.itemsPerPage
      if (state.searchParams) {
        const searchParams = {
          ...state.searchParams,
          _start: (page - 1) * itemsPerPage,
          _limit: itemsPerPage,
          _sort: 'createdAt:DESC',
          category,
          type,
        }
        const [totalItems, holidays] = await Promise.all([
          Holiday.count(searchParams),
          Holiday.search(searchParams),
        ])

        if (totalItems > (page - 1) * itemsPerPage || page === 1) {
          commit('changeState', {
            holidays,
            totalItems,
            itemsPerPage,
            searchParams,
          })
          const pageStart = (page - 1) * itemsPerPage + 1
          let pageStop = page * itemsPerPage
          pageStop = pageStop > totalItems || pageStop === -1 ? totalItems : pageStop
          const pageText = `${pageStart}-${pageStop} trên ${totalItems}`
          commit('setPageText', pageText)
        } else {
          const pages = rangeRight(1, page)
          for (let index = 0; index < pages; index++) {
            const selectedPage = pages[index]
            if (totalItems > (selectedPage - 1) * itemsPerPage) {
              dispatch('requestPageSettings', {})
              break
            }
          }
        }
      }
      commit('changeState', { loading: false })
    },
    async fetchHolidays({ commit }, params) {
      try {
        const holidays = await Holiday.fetch({ ...params })
        commit('setHolidays', holidays)
        return holidays
      } catch (e) {
        alert.error(e)
      }
    },
    async countHolidays({ commit }, options) {
      try {
        const count = await Holiday.count(options)
        commit('countHolidays', count)
      } catch (e) {
        alert.error(e)
      }
    },
    async fetchHoliday(_, id) {
      return Holiday.fetchOne(id)
    },
    async createHoliday({ dispatch }, payload) {
      try {
        const obj = await Holiday.create(payload)
        dispatch('requestPageSettings', { type: payload.type })
        alert.addSuccess()
        return obj
      } catch {
        alert.addError()
      }
    },
    async updateHoliday({ dispatch, commit }, payload) {
      try {
        const obj = await Holiday.update(payload.id, payload.data)
        commit('updateHoliday', obj)
        dispatch('requestPageSettings', {})
        alert.updateSuccess()
        return obj
      } catch {
        // alert.updateError(error)
      }
    },
    async deleteHoliday({ dispatch }, payload) {
      await Holiday.remove(payload.id)
      dispatch('requestPageSettings', { type: payload.type })
    },
    async getAffectedClasses({ commit }, params) {
      commit('changeState', { getClassLoading: true })
      const affectedClasses = await Holiday.getAffectedClasses(params)
      commit('setAffectedClasses', affectedClasses)
      commit('changeState', { getClassLoading: false })
    },
  },
  mutations: {
    setPageText(state, pageText) {
      state.pageText = pageText
    },
    setHolidays(state, holidays) {
      state.holidays = holidays
    },
    countHolidays(state, count) {
      state.count = count
    },
    updateHoliday(state, holiday) {
      state.holiday = holiday
    },
    setAffectedClasses(state, affectedClasses) {
      state.affectedClasses = affectedClasses
    },
  },
}
